import React from 'react';
import { Box, Button, Typography, Stack, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid';
import SessionCard from './SessionCard';
import ProjectCard from './ProjectCard';

const ContentGrid = ({ items, type, hasMore, loading, onLoadMore, total, ownerUsername }) => {
  if (!items || items.length === 0) return null;

  return (
    <Box>
      <Grid container spacing={2}>
        {items.map((item) => (
          <Grid item xs={12} md={6} key={item.shareToken}>
            {type === 'sessions' ? (
              <SessionCard session={item} ownerUsername={item.owner?.username || ownerUsername} />
            ) : (
              <ProjectCard project={item} />
            )}
          </Grid>
        ))}
      </Grid>

      {/* Load More + count indicator */}
      <Stack alignItems="center" spacing={1} sx={{ mt: 3 }}>
        {total > 0 && (
          <Typography variant="caption" color="text.disabled">
            Showing {items.length} of {total}
          </Typography>
        )}
        {hasMore && (
          <Button
            variant="outlined"
            onClick={onLoadMore}
            disabled={loading}
            sx={{ textTransform: 'none', borderRadius: 3, px: 4 }}
          >
            {loading ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
            Load More
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default ContentGrid;
